<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003607.installation.cellule.titre' | translate"
      [description]="'P0003607.installation.cellule.description' | translate"
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="'P0003607.installation.polarite' | translate"
      [nameCustom]="'P0003607.installation.activation' | translate"
      [value]="actionStack!.getValue('esIActivationInversionPolarite') !== 0"
      [information]="P0003607ESPPolariteModal"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.ElectrolyseurStandard_Installation,
          'esIActivationInversionPolarite',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (actionStack!.getValue('esIActivationInversionPolarite') === 1) {
      <app-label-configuration
        [titleListe]="'P0003607.installation.inversion' | translate"
        [value]="actionStack!.getValue('esPDureeInversionPolarite')"
        [liste]="P0003607DureeInversion"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage2,
            'esPDureeInversionPolarite',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    <app-larged-link
      [name]="'P0003607.installation.config.position' | translate"
      [textBeforeArrow]="
        P0003607PositionTypeEnum[this.currentForm!.controls['position']?.value]
          .label | translate
      "
      (onPress)="openModal()"
    >
    </app-larged-link>

    <app-label-description
      [description]="'P0003607.installation.polarite.description' | translate"
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
